import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import page from '../../assets/images/pageNotFound.svg';
import { buttonStyle2 } from '../../utils/commonStyle';
import { useTheme } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const theme = useTheme();
  const { t } = useTranslation();

  const navigation = useNavigate();

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;
  return (
    <Stack style={{ height: '100vh' }}>
      <Stack
        flex={1}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <img
          src={page}
          width={'240px'}
          height={'200px'}
        />
        <Typography
          className="fw-bold ff-Roboto fs-20 !mt-[20px]"
          color={text}
        >
          PAGE NOT FOUND
        </Typography>
        <Typography
          className="fw-regular ff-Roboto fs-14 !mt-[10px] !mb-[15px]"
          color={'#414141'}
        >
          We can’t seem to find a page you’re looking for.
        </Typography>
        <Button
          sx={[
            buttonStyle2,
            {
              color: theme.palette.background.main,
              backgroundColor: theme.palette.primary.dark,
              textTransform: 'uppercase',
              '&:hover': {
                // backgroundColor: theme.palette.secondary.main,
                // color: theme.palette.background.main,
              },
            },
          ]}
          style={{ width: '208px', height: '40px' }}
          variant="contained"
          onClick={() => {
            navigation('/')
          }}
        >
          {t('Back to dashboard')}
        </Button>
      </Stack>
    </Stack>
  );
}
